import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type AddParticipantsMutationVariables = {
  provingId: Types.Scalars['ID'],
  input: Types.ParticipantsAddInput
};


export type AddParticipantsMutation = (
  { __typename?: 'Mutation' }
  & { addParticipants: Array<(
    { __typename?: 'Participant' }
    & Pick<Types.Participant, '_id'>
  )> }
);

export type UpdateParticipantsMutationVariables = {
  provingId: Types.Scalars['ID'],
  batch: Array<Types.ParticipantBatchInput>
};


export type UpdateParticipantsMutation = (
  { __typename?: 'Mutation' }
  & { updateParticipants: Array<(
    { __typename?: 'Participant' }
    & Pick<Types.Participant, '_id'>
  )> }
);

export type DeleteParticipantsMutationVariables = {
  provingId: Types.Scalars['ID'],
  idsToDelete: Array<Types.Scalars['String']>
};


export type DeleteParticipantsMutation = (
  { __typename?: 'Mutation' }
  & { deleteParticipants: Array<(
    { __typename?: 'Participant' }
    & Pick<Types.Participant, '_id'>
  )> }
);

export type AccomodationsQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type AccomodationsQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title'>
  )> }
);

export type TrackHotelsQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type TrackHotelsQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'land' | 'place'>
  )> }
);

export type DataQueryVariables = {
  provingGroundId?: Types.Maybe<Types.Scalars['String']>
};


export type DataQuery = (
  { __typename?: 'Query' }
  & { resources: Array<(
    { __typename?: 'Resource' }
    & Pick<Types.Resource, '_id' | 'title' | 'type'>
  )>, maintenanceAreas: Array<(
    { __typename?: 'MaintenanceArea' }
    & Pick<Types.MaintenanceArea, 'maintenanceArea'>
    & { maintenanceHead: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'department'>
    )>> }
  )> }
);

export const AddParticipantsDocument = gql`
    mutation AddParticipants($provingId: ID!, $input: ParticipantsAddInput!) {
  addParticipants(provingId: $provingId, input: $input) {
    _id
  }
}
    `;
export type AddParticipantsMutationFn = ApolloReactCommon.MutationFunction<AddParticipantsMutation, AddParticipantsMutationVariables>;

    export function useAddParticipantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddParticipantsMutation, AddParticipantsMutationVariables>) {
      return ApolloReactHooks.useMutation<AddParticipantsMutation, AddParticipantsMutationVariables>(AddParticipantsDocument, baseOptions);
    };
export type AddParticipantsMutationHookResult = ReturnType<typeof useAddParticipantsMutation>;
export type AddParticipantsMutationResult = ApolloReactCommon.MutationResult<AddParticipantsMutation>;
export type AddParticipantsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddParticipantsMutation, AddParticipantsMutationVariables>;
export const UpdateParticipantsDocument = gql`
    mutation UpdateParticipants($provingId: ID!, $batch: [ParticipantBatchInput!]!) {
  updateParticipants(provingId: $provingId, batch: $batch) {
    _id
  }
}
    `;
export type UpdateParticipantsMutationFn = ApolloReactCommon.MutationFunction<UpdateParticipantsMutation, UpdateParticipantsMutationVariables>;

    export function useUpdateParticipantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateParticipantsMutation, UpdateParticipantsMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateParticipantsMutation, UpdateParticipantsMutationVariables>(UpdateParticipantsDocument, baseOptions);
    };
export type UpdateParticipantsMutationHookResult = ReturnType<typeof useUpdateParticipantsMutation>;
export type UpdateParticipantsMutationResult = ApolloReactCommon.MutationResult<UpdateParticipantsMutation>;
export type UpdateParticipantsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateParticipantsMutation, UpdateParticipantsMutationVariables>;
export const DeleteParticipantsDocument = gql`
    mutation DeleteParticipants($provingId: ID!, $idsToDelete: [String!]!) {
  deleteParticipants(provingId: $provingId, idsToDelete: $idsToDelete) {
    _id
  }
}
    `;
export type DeleteParticipantsMutationFn = ApolloReactCommon.MutationFunction<DeleteParticipantsMutation, DeleteParticipantsMutationVariables>;

    export function useDeleteParticipantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteParticipantsMutation, DeleteParticipantsMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteParticipantsMutation, DeleteParticipantsMutationVariables>(DeleteParticipantsDocument, baseOptions);
    };
export type DeleteParticipantsMutationHookResult = ReturnType<typeof useDeleteParticipantsMutation>;
export type DeleteParticipantsMutationResult = ApolloReactCommon.MutationResult<DeleteParticipantsMutation>;
export type DeleteParticipantsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteParticipantsMutation, DeleteParticipantsMutationVariables>;
export const AccomodationsDocument = gql`
    query Accomodations($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "lodging"}, type: {EQ: "accomodation"}, inactive: {EQ: false}}) {
    _id
    title
  }
}
    `;

    export function useAccomodationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccomodationsQuery, AccomodationsQueryVariables>) {
      return ApolloReactHooks.useQuery<AccomodationsQuery, AccomodationsQueryVariables>(AccomodationsDocument, baseOptions);
    };
      export function useAccomodationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccomodationsQuery, AccomodationsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<AccomodationsQuery, AccomodationsQueryVariables>(AccomodationsDocument, baseOptions);
      };
      
export type AccomodationsQueryHookResult = ReturnType<typeof useAccomodationsQuery>;
export type AccomodationsQueryResult = ApolloReactCommon.QueryResult<AccomodationsQuery, AccomodationsQueryVariables>;
export const TrackHotelsDocument = gql`
    query TrackHotels($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "lodging"}, type: {EQ: "hotel"}, inactive: {EQ: false}}) {
    _id
    title
    land
    place
  }
}
    `;

    export function useTrackHotelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TrackHotelsQuery, TrackHotelsQueryVariables>) {
      return ApolloReactHooks.useQuery<TrackHotelsQuery, TrackHotelsQueryVariables>(TrackHotelsDocument, baseOptions);
    };
      export function useTrackHotelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrackHotelsQuery, TrackHotelsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<TrackHotelsQuery, TrackHotelsQueryVariables>(TrackHotelsDocument, baseOptions);
      };
      
export type TrackHotelsQueryHookResult = ReturnType<typeof useTrackHotelsQuery>;
export type TrackHotelsQueryResult = ApolloReactCommon.QueryResult<TrackHotelsQuery, TrackHotelsQueryVariables>;
export const DataDocument = gql`
    query data($provingGroundId: String) {
  resources(filter: {rootId: {EQ: $provingGroundId}, category: {EQ: "ferryConnection"}}) {
    _id
    title
    type
  }
  maintenanceAreas {
    maintenanceArea
    maintenanceHead {
      _id
      type
      name
      firstName
      lastName
      department
    }
  }
}
    `;

    export function useDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataQuery, DataQueryVariables>) {
      return ApolloReactHooks.useQuery<DataQuery, DataQueryVariables>(DataDocument, baseOptions);
    };
      export function useDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataQuery, DataQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DataQuery, DataQueryVariables>(DataDocument, baseOptions);
      };
      
export type DataQueryHookResult = ReturnType<typeof useDataQuery>;
export type DataQueryResult = ApolloReactCommon.QueryResult<DataQuery, DataQueryVariables>;